import { render, staticRenderFns } from "./BlogLoginDialog.vue?vue&type=template&id=4c599798"
import script from "./BlogLoginDialog.vue?vue&type=script&lang=js"
export * from "./BlogLoginDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports